<template>
	<div class="MonthEmployee ">
		<svg-sprite width="20" height="20" :icon-id="getIcon()"></svg-sprite>
		<div>{{ getText() }}</div>
	</div>
</template>

<script>

export default {
	name: "MonthEmployee",
	props: {
		item: Object,
		line: Object
	},
	methods: {
		getText() {
			return this.line[this.item.value] === 0 ? 'Week' : 'Month';
		},
		getIcon() {
			return this.line[this.item.value] === 0 ? 'week' : 'month';
		},
	}
};
</script>

<style scoped lang="scss">
.MonthEmployee {
	width: 100%;
	min-width: 96px;
	display: flex;
	align-items: center;
	gap: 3px;
	flex-grow: 2;
	color: var(--card-color);
	svg {
		color: #8F90A6;
		display: block;
	}
}
</style>
